import React from 'react';

import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import useScreenShotContext from '../../../hooks/useScreenShotContext/useScreenShotContext';
import ScreenShotIcon from '../../../icons/ScreenShotIcon';

export default function ScreenShotButton(props: { disabled?: boolean; className?: string }) {
  const { setScreenShotFlag } = useScreenShotContext();

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <IconButton
      style={{ width: '48px', height: '48px', border: `solid 1px ${primaryColor}` }}
      className={props.className}
      onClick={setScreenShotFlag}
      disabled={props.disabled}
    >
      <ScreenShotIcon />
    </IconButton>
  );
}
